import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const host = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '2.4rem',
});

const item = style({
  position: 'relative',
  display: 'flex',
  selectors: {
    ['&:not(:last-child)::after']: {
      position: 'absolute',
      top: '3.2rem',
      left: '1.5rem',
      width: '0.2rem',
      height: '100%',
      backgroundImage: `linear-gradient(
    to bottom,
    rgba(var(--color-white-rgb), 0) 40%,
    var(--color-action-primary) 0%
  )`,
      backgroundRepeat: 'repeat-y',
      backgroundPosition: 'center',
      backgroundSize: '0.1rem 1.2rem',
      content: '""',
    },
  },
});

const itemBadge = style({
  flexShrink: 0,
  marginRight: '1rem',
  background: themeVars.color.semantic.surface.accentPrimary20,
  color: themeVars.color.semantic.text.neutral30,
});

export const css = {
  host,
  item,
  itemBadge,
};
